import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, IconButton, TextField, Typography, Grid, DialogActions, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { IoMdCloseCircleOutline } from "react-icons/io";
import Toggle from 'react-toggle';
import ApiRequestService from '../../../component/ApiRequestService';
import { NotificationManager } from 'react-notifications';
import { DEFAULT_LOCKOUT, DEFAULT_MASTERY_COUNT, DEFAULT_MAXIMUM_ATTEMPT, DEFAULT_NOCQC, DEFAULT_RANDOMIZE_CATEGORIES } from '../Constants';

const NewAssignmentModal = ({
    showModal,
    handleClose,
    course_id,
    onCompleteCreateAssignment
}) => {

    const [assignmentName, setAssignmentName] = useState("");
    const [isTest, setIsTest] = useState(false);

    const handleCreateAssignment = () => {
        if (course_id === null || course_id === undefined) {
            NotificationManager.error('Invalid course id', 'Error', 3000);
            return
        }
        let payload = {
            quiz_name: assignmentName,
            quiz_type: isTest ? 1 : 0,
            allow_practice: isTest ? false : true, // by default all quizzes are practicable
            course_id: course_id,
            randomize_categories: DEFAULT_RANDOMIZE_CATEGORIES,
            mastery_condition: DEFAULT_MASTERY_COUNT,
            maximum_attempted: DEFAULT_MAXIMUM_ATTEMPT,
            lockoutN: DEFAULT_LOCKOUT,
            NoCQC: DEFAULT_NOCQC,
        }

        console.debug("payload>>??", payload)

        ApiRequestService({
            method: 'post',
            url: '/addQuiz',
            data: payload
        }).then(res => {
            console.debug("res>>??", res)
            if (res && res.data && res.data.data) {
                NotificationManager.success("Created your assignment", "Success", 3000);
                handleClose();
                onCompleteCreateAssignment(res.data.data);
            }
        })
    }

    // console.debug("course_id>>??", course_id)

    return (
        <Dialog
            maxWidth="sm"
            fullWidth
            open={showModal}
        >
            <DialogTitle>
                <Typography fontSize={18} fontWeight={500}>
                    New Assignment
                </Typography>
            </DialogTitle>
            <IconButton
                aria-label="close"
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                })}
                onClick={handleClose}
            >
                <IoMdCloseCircleOutline fontSize={24} />
            </IconButton>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={8}>
                        <TextField
                            placeholder='Enter assignment name'
                            sx={{
                                width: "100%",
                            }}
                            onChange={event => {
                                setAssignmentName(event.target.value);
                            }}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <FormControl >
                                {/* <FormLabel>Assignment</FormLabel> */}
                                <RadioGroup
                                    row
                                    defaultValue={0}
                                    name="row-radio-buttons-group"
                                    onChange={() => {
                                        setIsTest(!isTest);
                                    }}
                                >
                                    <FormControlLabel value={0} control={<Radio />} label="Mastery" />
                                    <FormControlLabel value={1} control={<Radio />} label="Test" />
                                </RadioGroup>
                            </FormControl>

                            {/* <Toggle
                                onChange={() => {
                                    setIsTest(!isTest);
                                }}
                                icons={false} checked={isTest} className='custom-react-toggle'
                            />
                            <div style={{ fontWeight: 600, width: "100%" }}>Test</div> */}
                        </div>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose}>
                    Close
                </Button>
                <Button variant='contained' onClick={handleCreateAssignment}
                    disabled={assignmentName === ""}>
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NewAssignmentModal;
